import React, {useEffect, useState} from 'react'
import {IIssueOrgans, issueOrgansInitValues as initialValues} from '../../models/IssueOrgansModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {Input3} from '../../../../../../components/Forms/Input'
import {deleteIssueOrgans, updateIssueOrgans} from '../issue_organs-list/core/_requests'
import {IssueOrgans} from '../issue_organs-list/core/_models'
import {useParams} from 'react-router-dom'
import { Toolbar2 } from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import { PageTitle } from '../../../../../../_metronic/layout/core'

//import {useToast} from '../../../../../../app/layout/hooks/toast'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const issueOrgansSchema = Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
})

const FormIssueOrgansEdit: React.FC = () => {
  const intl = useIntl()
  const MySwal = withReactContent(Swal)
  const navigate = useNavigate()
  // const [uuid, setUuid] = useState('')
  const {uuid} = useParams()

  useEffect(() => {
    if (uuid) {
      getIssueOrgans(uuid)
    }
    // eslint-disable-next-line
  }, [])

  async function getIssueOrgans(uuid: string) {
    const {data} = await axios.get(API_URL + '/v1/issue_organs/' + uuid)
    const issueOrgans: IIssueOrgans = data.data
    if (issueOrgans.uuid) {
      formik.setFieldValue('uuid', issueOrgans.uuid)
    }
    if (issueOrgans.description) {
      formik.setFieldValue('description', issueOrgans.description)
    }
    if (issueOrgans.name) {
      formik.setFieldValue('name', issueOrgans.name)
    }

    return data
  }

  const [loading, setLoading] = useState(false)
  const formik = useFormik<IssueOrgans>({
    initialValues,
    validationSchema: issueOrgansSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        //await axios.put(API_URL + '/v1/projects/' + values.uuid, values)
        await updateIssueOrgans(values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'ISSUE_ORGANS.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/issueorgans', {replace: true})
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'ISSUE_ORGANS.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function resetInputs() {
    formik.resetForm()
  }

  async function deleteIssueOrgansF(uuid: string) {
    deleteIssueOrgans(uuid)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'ISSUE_ORGANS.SWAL_DELETE'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/issueorgans', {replace: true})
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'ISSUE_ORGANS.SWAL_DELETE_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
      })
  }

  function deleteMsgIssueOrgans() {
    MySwal.fire({
      title: intl.formatMessage({id: 'ISSUE_ORGANS.SWAL_DELETE_?'}),
      text: intl.formatMessage({id: 'COMMON.SWAL_DELETE_TEXT'}),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({id: 'COMMON.SWAL_DELETE_MSG'}),
      cancelButtonText: intl.formatMessage({id: 'COMMON.CANCEL_BUTTON'}),
    }).then((result) => {
      if (result.value) {
        if (uuid !== undefined) deleteIssueOrgansF(uuid)
      }
    })
  }

  return (
    <div className='card card-custom mt-n8'>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO NAME */}
            <div className='row '>
              <div className='col-lg-6 '>
                <Input3
                  title={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                  placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
                  {...formik.getFieldProps('name')}
                  required
                />
              </div>

              {/* FIM NAME */}

              {/* INICIO DESCRIÇÃO ----------------------*/}
              <div className='col-lg-6 '>
                <Input3
                  title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                  placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                  {...formik.getFieldProps('description')}
                />
              </div>
            </div>
            {/* FIM DESCRIÇÃO ------------------------------*/}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.EDIT_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.EDITING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>

              <button
                type='button'
                onClick={deleteMsgIssueOrgans}
                className='btn btn-sm btn-outline btn-outline-danger btn-active-danger ml-3'
              >
                {intl.formatMessage({id: 'COMMON.DELETE_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormIssueOrgansEdit}
